/**
 * AGC: Quest Panel Component for Origami Battle 2.0 - Version 6.7.0
 * AGC: Full-screen design matching Profile.tsx pattern
 * AGC: NO BONUSES - Only individual quest rewards
 * @author AGC (AI-Generated Code) with Cursor
 */

import React, { useState } from 'react'
import { DailyQuests } from './DailyQuests'
import { WeeklyQuests } from './WeeklyQuests'
import { MonthlyQuests } from './MonthlyQuests'
import { Sparkles, Calendar, CalendarDays, CalendarRange } from 'lucide-react'

type QuestTab = 'daily' | 'weekly' | 'monthly'

export const QuestPanel: React.FC = () => {
  const [activeTab, setActiveTab] = useState<QuestTab>('daily')

  // AGC: Tab configurations
  const tabs = [
    { id: 'daily', label: 'Daily', icon: Calendar },
    { id: 'weekly', label: 'Weekly', icon: CalendarDays },
    { id: 'monthly', label: 'Monthly', icon: CalendarRange }
  ] as const

  return (
    <main
      className="pb-[88px] px-3 text-white flex flex-col gap-2"
    >
      {/* AGC: Hero Header */}
      <section className="pb-3 border-b border-white/10">
        <div className="flex items-center justify-between">
          <div>
            <p className="text-[9px] uppercase tracking-[0.25em] text-slate-500">QUESTS</p>
            <h1 className="text-2xl font-bold leading-tight text-white">
              {activeTab === 'daily' && 'Daily Quests'}
              {activeTab === 'weekly' && 'Weekly Quests'}
              {activeTab === 'monthly' && 'Monthly Quests'}
            </h1>
            <p className="text-[11px] text-slate-400">
              Complete quests to earn OGB tokens
            </p>
          </div>
          <div className="w-10 h-10 rounded-full bg-gradient-to-br from-cyan-500/20 to-purple-500/20 flex items-center justify-center border border-white/10">
            <Sparkles className="w-5 h-5 text-cyan-300" />
          </div>
        </div>
      </section>

      {/* AGC: Tabs */}
      <section className="pb-2 border-b border-white/10">
        <div className="flex gap-1">
          {tabs.map((tab) => {
            const Icon = tab.icon
            return (
              <button
                key={tab.id}
                onClick={() => setActiveTab(tab.id)}
                className={`flex-1 px-3 py-2 rounded-lg text-xs font-semibold transition-all flex items-center justify-center gap-1.5 ${
                  activeTab === tab.id
                    ? 'bg-gradient-to-r from-blue-500 to-purple-500 text-white shadow-lg shadow-blue-500/20'
                    : 'bg-slate-900/60 border border-white/10 text-slate-400 hover:bg-slate-800 hover:text-slate-300'
                }`}
              >
                <Icon className="w-3.5 h-3.5" />
                {tab.label}
              </button>
            )
          })}
        </div>
      </section>

      {/* AGC: Quest Content */}
      <section className="flex-1">
        {activeTab === 'daily' && <DailyQuests />}
        {activeTab === 'weekly' && <WeeklyQuests />}
        {activeTab === 'monthly' && <MonthlyQuests />}
      </section>
    </main>
  )
}
